export enum AudioComponent {
  Article = 'article',
  Message = 'message',
  SharedAudio = 'sharedAudio',
  SharedVoice = 'sharedVoice',
}
